<mat-icon (click)="closeSheet()" class="mat-icon__close">close</mat-icon>
<app-user-profile-menu [closeSheet]="closeSheet.bind(this)"></app-user-profile-menu>
